<template>
    <div>
        <p>
            Welcome to Play Virtuoso, the world's virtual stage for music 
            education, inspiring the musicians of tomorrow.
        </p>
        <p>
            You're now logged into your account and you have verified your email address,
            that's the first step towards achieving your goals.
        </p>
        <p>
            We'd like to ask you for some extra information to give you the best experience
            possible.
        </p>

        <div class="row">
            <div class="col-md-6">
                <button class="btn btn-primary mt-3" @click="start">Start</button>
            </div>

            <div class="col-md-6 align-self-end">
                <div class="text-right">
                    <button class="btn btn-secondary btn-sm skip" @click="skip">Skip</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            return {
            }
        },

        mounted() {
        },

        methods: {
            // Skip
            skip() {
                axios.post('/api/me/complete-onboarding').then((response) => {
                    location.href = "/home";
                });
            },

            // Start
            start() {
                Bus.$emit('stepComplete', {
                    'step': 'welcome',
                    'skip': false,
                });
            },
        }
    }
</script>